<i18n src="./../../i18n/single_faq_page.json"></i18n>

<template>
    <div id="single-faq-page">
        <div class="container-fluid" v-if="loaded">
            <vue-headful
                :title="$t('pageTitle')"
                :description="$t('pageDescription')"
                :url="pageUrl"/>
            <navigation-bar/>

            <div id="paralax-subpage-section" class="lazy jumbotron mt-page-nav-image"
                 data-bg="/assets/mt-cart-header-image.jpg">
                <div class="container">
                    <p class="display-1 mt-f-regular par-text-1" style="opacity: 0.5;">FAQ</p>
                </div>
            </div>

            <div class="container-fluid mt-subpage-section m-0 p-0">
                <div class="container-fluid m-0 p-0">
                    <div class="lazy container-fluid">
                        <div class="container">
                            <div class="content-container p-3 pt-5">
                                <div class="row justify-content-center mt-5">
                                    <div class="col-md-11 col mt-faq-q">
                                        <div class="row">
                                            <div class="col-lg-1 col-2 m-0 p-0">
                                                <img class="lazy my-auto" data-src="/assets/mt-faq-q-bar.png" alt="Q">
                                                <span class="faq-letter mt-f-regular mt-c-blue-regular">Q.</span>
                                            </div>
                                            <div class="col-lg-11 col-10 m-0 p-0 my-auto">
                                                <p class="m-0 p-0">{{ content.question }}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-11 mt-faq-a">
                                        <div class="row pt-2">
                                            <div class="col-lg-1 col-2 m-0 p-0">
                                                <span class="faq-letter mt-f-regular mt-c-grey-light my-auto">A.</span>
                                            </div>
                                            <div class="col-lg-11 col-10 m-0 p-0 my-auto">
                                                <p class="mt-c-grey m-0 p-0" v-html="content.answer"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <main-footer/>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import NavigationBar from "@/components/commons/NavigationBar";
    import MainFooter from "@/components/commons/MainFooter";
    import axios from "axios";
    import {Const} from "@/main";
    import $ from "jquery";
    import LazyLoad from "vanilla-lazyload";

    var lazyLoadInstance = new LazyLoad({
      elements_selector: ".lazy"
    });

    export default {
      name: "SingleFaqPage",
      components: {MainFooter, NavigationBar},
      data() {
        return {
          locale: this.$i18n.locale,
          content: {},
          loaded: false,
          pageUrl: Const.HOST + this.$route.path
        }
      },
      mounted() {
        axios.get(`${Const.API_HOST}/${this.locale}/content/faq/page`, {
          params: {
            "url": `/${this.$route.params.pageName}`
          }
        }).then(function (response) {
            return response.data;
          }).catch(function (error) {
          // eslint-disable-next-line no-console
          console.log(error);
        }).then(body => {
          this.content = body
          this.loaded = true

          this.$nextTick(() => {
            lazyLoadInstance.update()
          })
        });

        $(document).scroll(function () {
          var $nav = $(".navbar-light");
          $nav.removeClass('initial');
          $nav.toggleClass('scrolled', $(this).scrollTop() > $nav.height());
        });
      }
    }
</script>

<style scoped>
    #paralax-subpage-section {
        height: 200px;
    }

    .faq-letter {
        vertical-align: middle;
    }
</style>